<template>
  <!-- Withdraw -->
  <div id="Withdraw">
    <!-- 内容区域 -->

    <el-container style="width: 100%;height: 100%; background: #fff;">
      <el-header>
        <mu-appbar class="is-full-width" v-bind:title="titleStr" color="#fff" textColor="#303644" z-depth=0>
          <mu-button @click="leftBtn" icon slot="left">
            <mu-icon value="arrow_back"></mu-icon>
          </mu-button>
        </mu-appbar>
      </el-header>

      <el-main>
        <!-- <el-container style="width: 100%;height: 100%;background: #fff;"> -->
          <el-row>
          <el-input
            placeholder="Blockchain Address"
            v-model="input"
            clearable>
          </el-input>
          </el-row>

          <el-row>
            <!-- <el-input v-model="form.name" autocomplete="off" οnkeyup="value=value.replace(/[^\d]/g,'')"></el-input> -->
          <el-input
            placeholder="Withdrawal Amount"
            v-model="Amount"
            autocomplete="off" οnkeyup="value=value.replace(/[^\d]/g,'')"
            clearable>
          </el-input>
          </el-row>

          <!-- <el-row class="erow">
            <el-col :span="12"><p style="color: #303644;font-weight: bold;">Currency:</p></el-col>
            <el-col :span="12"><p style="color: #303644;font-weight: bold;">{{Name}}</p></el-col>
          </el-row> -->
          <el-row class="erow">
            <el-col :span="12"><p style="color: #303644;font-weight: bold;">Miners'expenses:</p></el-col>
            <el-col :span="12"><p style="color: #303644;font-weight: bold;">0.0005&#160;{{Name}}</p></el-col>
          </el-row>
          <el-row class="erow">
            <el-button @click="TransferClick" class="ETLBtn" fill>Transfer immediately</el-button>
          </el-row>

        <!-- </el-container> -->
      </el-main>
      <!-- <el-footer>
          <BottomNav style="height: 100%; width: 100%;"></BottomNav>
          </el-footer> -->
    </el-container>


  </div>
</template>

<script>
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        titleStr: 'Withdraw',
        input: '',
        Amount:'0.0',
        Name: '',
        Num: ''
      }
    },
    mounted() {

  //     var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
  //     this.UserType = UserInfo.type;

  //     window.T_Details = this;
  // console.log(this.$route.query.Name)
  // console.log(this.$route.query.Num)
      this.Name = this.$route.query.Name;
      // this.Num = this.$route.query.Num;
      this.Amount = this.Num;
      // this.titleStr = this.$route.query.Name;
    },
    methods: {
      leftBtn() {
        this.$router.go(-1); //返回上一层
      },
      TransferClick() {
        if(this.input.length==0||this.Amount.length==0){
          this.$message.error("The withdrawal amount is wrong");
          return;
        }
        let params = new URLSearchParams();
            params.append('currency', this.Name);
            params.append('address', this.input);
            params.append('count', this.Amount);
        params.append('token',sStorage.getItem("token"));

              const that = this;
            this.$http.post('/record/Withdraw', params)
              .then(function(response) {
                console.log(response.data);
                if (response.data.success || response.data.code == 1) {
                  that.$message(response.data.message);
                  that.$router.go(-2); //返回上一层
                }else if (response.data.code == -1){
                  sStorage.clear();
                  that.$router.replace("/");
                  that.$message.error(response.data.message);
                } else {
                  that.$message.error(response.data.message);
                }
              })
              .catch(function(error) {
                console.log(error);
              });
      }
    },
    components: {
    }
  };
</script>

<style>
  @import '../../../../Comm/css/CommCSS.css';
  /* #Withdraw .mu-appbar .mu-appbar-title {
     text-align: center;
   } */
   #Withdraw .is-full-width {
     width: 100%;
     height: 100%;
   }

   #Withdraw .content {
     flex: 1
   }

   #Withdraw .el-header {
    padding: 0 0px;
   }

   #Withdraw .el-main {
       padding: 0px;
   }

   #Withdraw .el-input__inner {
     background-color: #dcdfe6;
       border-radius: 1.25rem;
    margin: 0 auto; /*水平居中*/
    margin-top: 1.25rem;
    display: flex;
    width:80%;
   color: #303644;
       /* margin-left: 0.625rem; */
   }

   #Withdraw .erow{
    margin: 0 auto; /*水平居中*/
    margin-top: 1.25rem;
    /* display: flex; */
    width:80%;
   }
  #Withdraw .ETLBtn {
    margin: 0 auto; /*水平居中 */
    display: flex;
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Extract/Withdraw/Withdraw.vue